// ── LandingPageData.ts ─────────────────────────────────────────────────────────

export const heroStats = [
  { value: '2,400+', label: 'Active Hoardings' },
  { value: '180+', label: 'Cities Covered' },
  { value: '12K+', label: 'Advertisers' },
  { value: '₹50Cr+', label: 'Ad Spend Facilitated' },
];

export const featuredListings = [
  {
    id: 'fl1',
    title: 'Delhi Highway Premium Billboard',
    location: 'NH-48, Gurgaon Expressway, New Delhi',
    city: 'New Delhi',
    mediaType: 'Billboard',
    size: '40×20',
    dailyViews: '15,500',
    dailyTraffic: '3.5L',
    rating: 4.8,
    reviews: 23,
    price: 85000,
    badge: 'Top Rated',
    badgeColor: '#f97316',
    image: 'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=800&q=80',
  },
  {
    id: 'fl2',
    title: 'Mumbai Juhu Beach LED Screen',
    location: 'Juhu Tara Road, Mumbai',
    city: 'Mumbai',
    mediaType: 'Digital Screen',
    size: '30×60',
    dailyViews: '6,800',
    dailyTraffic: '3.2L',
    rating: 4.6,
    reviews: 41,
    price: 100000,
    badge: 'Premium',
    badgeColor: '#8b5cf6',
    image: 'https://images.unsplash.com/photo-1567306226416-28f0efdc88ce?w=800&q=80',
  },
  {
    id: 'fl3',
    title: 'Bangalore Electronic City Hoarding',
    location: 'Electronic City Flyover, Bangalore',
    city: 'Bangalore',
    mediaType: 'Hoarding',
    size: '20×40',
    dailyViews: '1,290',
    dailyTraffic: '1.8L',
    rating: 4.7,
    reviews: 18,
    price: 65000,
    badge: 'Trending',
    badgeColor: '#10b981',
    image: 'https://images.unsplash.com/photo-1570459027562-4a916cc6113f?w=800&q=80',
  },
];

export const advantages = [
  {
    icon: 'MapPin',
    title: 'Find Nearby Hoardings',
    description: 'Discover available advertising spaces in your target area with precise location filtering and map view.',
    color: '#f97316',
  },
  {
    icon: 'TrendingUp',
    title: 'Grow Your Business',
    description: 'Reach thousands of potential customers daily with high-visibility outdoor advertising that converts.',
    color: '#10b981',
  },
  {
    icon: 'ShieldCheck',
    title: 'Verified & Secure',
    description: 'All listings are verified. Transact safely with escrow payments and owner-direct contacts.',
    color: '#3b82f6',
  },
  {
    icon: 'Zap',
    title: 'Quick Booking',
    description: 'Book your preferred hoarding in minutes. Instant confirmation and hassle-free payment process.',
    color: '#8b5cf6',
  },
  {
    icon: 'Award',
    title: 'Premium Locations',
    description: 'Access the most premium advertising spaces in high-traffic areas across all major cities.',
    color: '#f43f5e',
  },
  {
    icon: 'Headphones',
    title: '24/7 Support',
    description: 'Dedicated support team available round the clock to assist you with any queries.',
    color: '#f59e0b',
  },
];

export const testimonials = [
  {
    id: 't1',
    quote: 'Exceptional service and premium locations. Our brand visibility increased by 200% in just 2 months.',
    author: 'Amit Patel',
    role: 'Brand Manager, Tata Motors',
    rating: 5,
    avatar: 'AP',
    color: '#f97316',
  },
  {
    id: 't2',
    quote: 'Adroj made outdoor advertising simple and cost-effective. We scaled from 3 to 40 locations in one campaign.',
    author: 'Sneha Krishnan',
    role: 'Marketing Head, PhonePe',
    rating: 5,
    avatar: 'SK',
    color: '#3b82f6',
  },
  {
    id: 't3',
    quote: 'The platform is incredibly intuitive. Best ROI we have ever seen from an outdoor campaign. Highly recommend.',
    author: 'Rahul Mehta',
    role: 'CMO, Nykaa',
    rating: 5,
    avatar: 'RM',
    color: '#10b981',
  },
];

export const trustedBrands = [
  'TVS', 'Samsung', 'Bajaj', 'Maruti', 'PhonePe', 'Nykaa', 'Swiggy', 'HDFC',
];

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Explore', href: '#listings' },
  { label: 'My Hoardings', href: '#' },
];

export const footerLinks = {
  'Quick Links': ['Browse Hoardings', 'List Your Space', 'Pricing', 'How It Works'],
  'Support': ['Help Center', 'Contact Us', 'FAQs', 'Report an Issue'],
  'Legal': ['Terms of Service', 'Privacy Policy', 'Cookie Policy', 'Refund Policy'],
};
